var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66699C6.77484 1.66699 4.1665 4.27533 4.1665 7.50033C4.1665 11.8753 9.99984 18.3337 9.99984 18.3337C9.99984 18.3337 15.8332 11.8753 15.8332 7.50033C15.8332 4.27533 13.2248 1.66699 9.99984 1.66699ZM5.83317 7.50033C5.83317 5.20033 7.69984 3.33366 9.99984 3.33366C12.2998 3.33366 14.1665 5.20033 14.1665 7.50033C14.1665 9.90033 11.7665 13.492 9.99984 15.7337C8.2665 13.5087 5.83317 9.87533 5.83317 7.50033Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 9.58366C11.1504 9.58366 12.0832 8.65092 12.0832 7.50033C12.0832 6.34973 11.1504 5.41699 9.99984 5.41699C8.84924 5.41699 7.9165 6.34973 7.9165 7.50033C7.9165 8.65092 8.84924 9.58366 9.99984 9.58366Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a370103756bbfff3cceb8a7181c8f5e8.svg";
export { ForwardRef as ReactComponent };